const it = {
  nav: {
    home: "Home",
    shop: "Shop",
    map: "Mappa",
    calculator: "Risparmio",
    compatibility: "Compatibilita",
    about: "Chi Siamo",
    howItWorks: "Come Funziona",
    faq: "FAQ",
    contact: "Contatti",
    cart: "Carrello"
  },
  hero: {
    title: "Connesso Ovunque",
    subtitle: "Attivazione eSIM istantanea per 190+ paesi. Nessuna SIM fisica necessaria.",
    searchPlaceholder: "Dove stai viaggiando?",
    cta: "Esplora Tutte le eSIM",
    searchHint: "Cerca un paese o clicca sui punti del globo",
    exploreMap: "Esplora Mappa",
    tagline1: "Connesso all'istante. Niente negozi SIM, nessuna attesa.",
    tagline2: "Dimentica la ricerca del WiFi. La tua eSIM ti tiene online.",
    tagline3: "Condividi ogni momento. Sempre connesso all'estero.",
    tagline4: "Atterra e connettiti. eSIM pronta prima del tuo arrivo.",
    tagline5: "Muoviti come un locale. Dati ovunque tu vada.",
    tagline6: "Niente costi di roaming. Solo pura connessione.",
    tagline7: "Resta connesso in oltre 209 paesi nel mondo.",
    destinations: "Destinazioni",
    coverage: "Copertura",
    instantDelivery: "Consegna Istantanea"
  },
  products: {
    title: "Destinazioni Popolari",
    viewAll: "Vedi Tutte",
    addToCart: "Aggiungi",
    buyNow: "Acquista Ora",
    viewPlans: "Vedi Piani",
    data: "Dati",
    validity: "Validita",
    countries: "paesi",
    from: "da",
    topDestinations: "Top Destinazioni",
    topDestinationsDesc: "Le destinazioni piu richieste dai nostri clienti. Connettiti ovunque nel mondo.",
    discoverAll: "Scopri tutte le 213+ destinazioni",
    compareHint: "Clicca l'icona bilancia per confrontare i piani",
    filters: {
      all: "Tutte",
      europe: "Europa",
      asia: "Asia",
      northAmerica: "N. America",
      southAmerica: "S. America",
      middleEast: "Medio Oriente",
      africa: "Africa",
      caribbean: "Caraibi",
      oceania: "Oceania"
    }
  },
  features: {
    title: "Perche Sceglierci",
    instant: { title: "Attivazione Istantanea", desc: "Connettiti in pochi minuti. Scansiona il QR code e sei pronto." },
    global: { title: "Copertura Globale", desc: "190+ paesi coperti. Una eSIM, infinite possibilita." },
    savings: { title: "Risparmia fino al 90%", desc: "Nessun costo roaming. Prezzi trasparenti senza costi nascosti." },
    support: { title: "Supporto 24/7", desc: "Il nostro team e qui per aiutarti sempre, ovunque." }
  },
  howItWorks: {
    title: "Come Funziona",
    step1: { title: "Scegli il Piano", desc: "Seleziona destinazione e piano dati" },
    step2: { title: "Ricevi eSIM", desc: "Ricevi il QR code via email istantaneamente" },
    step3: { title: "Scansiona e Connettiti", desc: "Scansiona col telefono e naviga" }
  },
  cart: {
    title: "Il Tuo Carrello",
    empty: "Il carrello e vuoto",
    total: "Totale",
    checkout: "Vai al Checkout",
    remove: "Rimuovi",
    continueShopping: "Continua lo Shopping"
  },
  checkout: {
    title: "Checkout",
    billing: "Dati di Fatturazione",
    payment: "Metodo di Pagamento",
    firstName: "Nome",
    lastName: "Cognome",
    email: "Email",
    phone: "Telefono",
    address: "Indirizzo",
    city: "Citta",
    country: "Paese",
    postalCode: "CAP",
    placeOrder: "Conferma Ordine",
    processing: "Elaborazione...",
    creditCard: "Carta di Credito",
    paypal: "PayPal",
    acceptTerms: "Accetto i Termini e Condizioni",
    couponCode: "Codice Sconto",
    travelBundle: "Bundle Viaggio",
    upsellFrom: "da",
    upsellAdd: "Aggiungi",
    applyCoupon: "Applica",
    couponApplied: "Coupon applicato!",
    discount: "Sconto",
    subtotal: "Subtotale",
    orderSummary: "Riepilogo Ordine",
    securePayment: "Pagamento sicuro con",
    eurPaymentNote: "Pagamento elaborato in EUR ({{amount}}). La tua banca convertira nella valuta locale.",
    orderConfirmed: "Il tuo ordine e stato confermato. Riceverai il QR code eSIM via email.",
    totalPaid: "Totale pagato",
    orderPlaced: "Ordine effettuato con successo!",
    orderNumber: "Ordine",
    receiveQR: "Riceverai il QR code della tua eSIM via email a breve.",
    orderTotal: "Totale Ordine",
    verificationExpired: "Verifica scaduta",
    paymentFailed: "Pagamento non riuscito",
    verificationExpiredDesc: "Non siamo riusciti a verificare il pagamento. Controlla la tua email per conferma.",
    paymentFailedDesc: "Il pagamento non e andato a buon fine. Riprova.",
    backToCheckout: "Torna al Checkout",
    cardBrands: "Visa, Mastercard, Amex",
    paypalAccount: "Account PayPal",
    checkDevice: "Verifica il tuo dispositivo",
    checkDeviceDesc: "Prima di completare l'acquisto, assicurati che il tuo dispositivo supporti le eSIM.",
    verifyingPayment: "Verifica pagamento...",
    verifyingPaymentDesc: "Attendere, stiamo verificando il tuo pagamento",
    paymentCompleted: "Pagamento Completato!",
    processingPaypal: "Elaborazione pagamento PayPal...",
    total: "Totale",
    needInvoice: "Hai bisogno di fattura?",
    invoiceEntity: "Fattura da:",
    companyName: "Azienda / Nome Completo",
    invoiceAddress: "Indirizzo di Fatturazione"
  },
  footer: {
    tagline: "La tua porta verso la connettivita globale",
    quickLinks: "Link Rapidi",
    support: "Supporto",
    legal: "Legale",
    privacy: "Privacy Policy",
    terms: "Termini di Servizio",
    refund: "Politica Rimborsi",
    copyright: "Tutti i diritti riservati",
    locations: "Le Nostre Sedi",
    euHQ: "Sede Europea",
    usHQ: "Sede U.S.A.",
    serviceBy: "Un servizio di"
  },
  common: {
    loading: "Caricamento...",
    error: "Qualcosa e andato storto",
    success: "Successo!",
    close: "Chiudi",
    back: "Indietro",
    next: "Avanti",
    search: "Cerca",
    or: "OPPURE",
    save: "Salva",
    edit: "Modifica",
    delete: "Elimina",
    cancel: "Annulla",
    confirm: "Conferma",
    noResults: "Nessun risultato trovato",
    optional: "opzionale"
  },
  auth: {
    welcomeBack: "Bentornato",
    createAccount: "Crea Account",
    signIn: "Accedi",
    signUp: "Registrati",
    signInDesc: "Accedi per gestire le tue eSIM",
    signUpDesc: "Unisciti a eSIM4You oggi",
    continueGoogle: "Continua con Google",
    forgotPassword: "Password dimenticata?",
    fullName: "Nome completo",
    email: "Email",
    password: "Password",
    backToSignIn: "Torna al Login",
    resetPassword: "Reimposta Password",
    sendResetCode: "Invia Codice di Reset",
    checkEmail: "Controlla la tua email",
    resetCodeSent: "Abbiamo inviato un codice di reset a",
    enterEmail: "Inserisci la tua email per ricevere un codice di reset",
    enterResetCode: "Inserisci codice di reset",
    newPassword: "Nuova password",
    passwordReset: "Password Reimpostata!",
    passwordResetSuccess: "La tua password e stata reimpostata con successo. Ora puoi accedere.",
    noAccount: "Non hai un account?",
    haveAccount: "Hai gia un account?"
  },
  about: {
    title: "Chi Siamo",
    subtitle: "La nostra missione e rendere la connettivita internazionale semplice, conveniente e istantanea. Basta costi di roaming esorbitanti o ricerche di SIM locali.",
    stats: {
      destinations: "Destinazioni",
      customers: "Clienti",
      networkSpeed: "Velocita Rete",
      support: "Supporto"
    },
    storyTitle: "La Nostra Storia",
    storyP1: "eSIM4You nasce da una semplice frustrazione: perche restare connessi in viaggio e ancora cosi complicato e costoso? Fondata da TelcaVoIP International EU, azienda europea di telecomunicazioni con profonde radici in VoIP e soluzioni di connettivita, ci siamo proposti di cambiare le cose.",
    storyP2: "Con sede in Europa e operazioni sia nell'UE che negli USA, sfruttiamo la nostra esperienza nel settore delle telecomunicazioni e le partnership con oltre 200 operatori mobili in tutto il mondo per offrire piani dati eSIM convenienti, affidabili e consegnati in pochi secondi.",
    storyP3: "Che tu sia un viaggiatore d'affari che si sposta tra citta, un nomade digitale che esplora nuovi paesi, o una famiglia in vacanza, ci assicuriamo che tu sia sempre connesso. Niente cambio SIM, niente visite in negozio, nessun problema.",
    valuesTitle: "Perche Sceglierci",
    values: {
      connectivity: { title: "Connettivita Globale", desc: "Collaboriamo con i migliori operatori mobili al mondo per offrire copertura dati affidabile in oltre 200 destinazioni in tutti i continenti." },
      delivery: { title: "Consegna Istantanea", desc: "Nessuna attesa, nessuna spedizione. La tua eSIM viene consegnata digitalmente in pochi secondi. Scansiona il QR code e sei connesso." },
      secure: { title: "Sicuro e Trasparente", desc: "Azienda con sede in UE conforme al GDPR. Prezzi trasparenti senza costi nascosti. Pagamenti sicuri via Stripe e PayPal." },
      customer: { title: "Il Cliente Prima di Tutto", desc: "Dal controllo compatibilita dispositivi alle guide di installazione, ci assicuriamo che ogni passo del tuo viaggio sia semplice e supportato." }
    },
    testimonialsTitle: "Cosa Dicono i Nostri Clienti",
    testimonials: {
      t1: { name: "Marco R.", location: "Milano, IT", text: "Fantastico! Ho comprato una eSIM per il Giappone e in 2 minuti ero connesso. Prezzi imbattibili rispetto al roaming." },
      t2: { name: "Sarah K.", location: "Berlino, DE", text: "Facilissima da configurare. L'ho usata in 5 paesi europei senza problemi. La riusero sicuramente!" },
      t3: { name: "Pierre L.", location: "Parigi, FR", text: "Servizio eccellente. Il QR code e arrivato subito e la guida all'installazione era chiarissima. Consigliatissimo." },
      t4: { name: "Anna W.", location: "Varsavia, PL", text: "Finalmente un provider eSIM affidabile in Europa! L'ho usata in Thailandia e ha funzionato perfettamente. Ottimo supporto clienti." }
    },
    companyTitle: "TelcaVoIP International EU",
    companySubtitle: "Azienda Europea di Telecomunicazioni",
    companyLocations: "Sede UE | Operazioni USA",
    poweredBy: "Powered by TelcaVoIP.AI"
  },
  chatbot: {
    title: "Supporto TelcaVoIP eSIM",
    subtitle: "Risposte immediate",
    welcome: "Ciao! Sono l'assistente TelcaVoIP eSIM. Come posso aiutarti oggi? Scegli un argomento qui sotto o scrivi la tua domanda.",
    whatElse: "Posso aiutarti con altro?",
    inputPlaceholder: "Scrivi la tua domanda...",
    allTopics: "Tutti gli argomenti",
    fallback: "Mi dispiace, non ho una risposta per questa domanda. Contatta il nostro team di supporto:",
    technician: "Un tecnico rispondera a breve. Includi il numero d'ordine se applicabile.",
    categories: {
      installation: "Installazione",
      compatibility: "Compatibilita",
      orders: "Ordini e Consegna",
      coverage: "Copertura e Dati",
      refunds: "Rimborsi e Supporto"
    },
    faq: {
      installHow: { q: "Come installo una eSIM?", a: "Dopo l'acquisto, riceverai un QR code via email.\n\n**iPhone:** Impostazioni > Cellulare > Aggiungi eSIM > Scansiona QR Code\n**Android:** Impostazioni > Rete > SIM > Aggiungi eSIM > Scansiona QR Code\n\nRicorda di abilitare il Roaming Dati quando arrivi a destinazione." },
      installWhen: { q: "Quando devo installare la eSIM?", a: "Puoi installarla in qualsiasi momento prima del viaggio. Ti consigliamo di installarla **prima della partenza** mentre sei connesso al WiFi. Potrai poi attivarla quando arrivi a destinazione." },
      installMultiple: { q: "Posso installare la eSIM su piu dispositivi?", a: "No, ogni QR code eSIM puo essere installato su **un solo dispositivo**. Una volta installato, non puo essere trasferito su un altro dispositivo." },
      compatible: { q: "Il mio dispositivo e compatibile con eSIM?", a: "La maggior parte degli smartphone moderni supporta eSIM, tra cui:\n- **iPhone** XR e successivi\n- **Samsung** Galaxy S20 e successivi\n- **Google** Pixel 3 e successivi\n\nUsa il nostro **Verificatore di Compatibilita** per controllare il tuo dispositivo." },
      phoneCase: { q: "La eSIM funziona con la custodia del telefono?", a: "Si! La eSIM e una SIM digitale, non c'e nessuna scheda fisica. Funziona indipendentemente dalla custodia o dagli accessori del telefono." },
      dualSim: { q: "Posso usare eSIM e SIM normale contemporaneamente?", a: "Si! La maggior parte dei dispositivi compatibili con eSIM supporta **Dual SIM** (SIM fisica + eSIM). Puoi mantenere attivo il tuo numero e usare la eSIM per i dati all'estero." },
      deliveryTime: { q: "Quanto velocemente ricevero la mia eSIM?", a: "Le eSIM vengono consegnate **istantaneamente** via email dopo il pagamento. Controlla la tua casella di posta (e la cartella spam) per il QR code. Puoi trovarlo anche nel tuo account sotto \"Le Mie eSIM\"." },
      noEmail: { q: "Non ho ricevuto l'email con la eSIM", a: "Controlla prima la **cartella spam/posta indesiderata**. Se ancora non la trovi:\n1. Accedi al tuo account\n2. Vai alla scheda \"Le Mie eSIM\"\n3. Contatta il supporto con il numero d'ordine" },
      paymentMethods: { q: "Quali metodi di pagamento accettate?", a: "Accettiamo:\n- **Carte di Credito/Debito** (Visa, Mastercard, Amex) tramite Stripe\n- **PayPal**\n\nTutti i pagamenti sono elaborati in modo sicuro." },
      speeds: { q: "Che velocita posso aspettarmi?", a: "Le nostre eSIM supportano reti **4G/LTE** e **5G** (dove disponibile). Le velocita effettive dipendono dalle condizioni della rete locale e dalle capacita del tuo dispositivo." },
      dataRunsOut: { q: "Cosa succede quando finiscono i dati?", a: "Quando il tuo traffico dati si esaurisce, la eSIM smettera di fornire dati. Puoi acquistare un nuovo piano dal nostro sito. Alcuni piani offrono dati illimitati con velocita ridotta dopo l'esaurimento del traffico ad alta velocita." },
      phoneCalls: { q: "Posso fare telefonate con la eSIM?", a: "I nostri piani eSIM sono **solo dati**. Puoi effettuare chiamate usando app come WhatsApp, FaceTime, Skype o Zoom tramite la connessione dati. Per le chiamate tradizionali, usa la tua SIM normale." },
      refund: { q: "Posso ottenere un rimborso?", a: "- **Prima dell'attivazione:** Rimborso completo entro 14 giorni\n- **Dopo l'attivazione:** Rimborsi non disponibili (prodotto digitale consumato)\n- **Problemi tecnici:** Contatta il supporto per assistenza o sostituzione" },
      notWorking: { q: "La mia eSIM non funziona", a: "Prova questi passaggi:\n1. Assicurati che il **Roaming Dati** sia abilitato\n2. Riavvia il dispositivo\n3. Verifica di aver selezionato la eSIM per i dati mobili\n4. Controlla di essere in un paese coperto\n\nSe il problema persiste, contatta il supporto." },
      contactSupport: { q: "Come contatto il supporto?", a: "Puoi raggiungerci su:\n- **WhatsApp:** {{WHATSAPP}}\n- Tempo di risposta: entro 24 ore\n\nIncludi il tuo **numero d'ordine** per un'assistenza piu rapida." }
    }
  },
  compatibility: {
    title: "Verifica Compatibilita eSIM",
    subtitle: "Verifica se il tuo dispositivo supporta eSIM prima dell'acquisto",
    searchPlaceholder: "Digita marca e modello del telefono (es. iPhone 15, Galaxy S24)...",
    searchDevice: "Cerca il tuo dispositivo...",
    search: "Cerca",
    selectDevice: "Seleziona Dispositivo",
    selectBrand: "Seleziona marca...",
    selectModel: "Seleziona modello...",
    compatible: "Compatibile con eSIM!",
    notCompatible: "Non Compatibile con eSIM",
    notCompatibleDesc: "Questo dispositivo non supporta eSIM. Puoi comunque usare una SIM fisica per la connettivita in viaggio.",
    checkAnother: "Controlla un altro dispositivo",
    checkCompatibility: "Verifica Compatibilita eSIM",
    deviceNotFound: "Dispositivo non trovato nel nostro database",
    deviceNotFoundDesc: "Prova a selezionare il tuo dispositivo dalla lista, o controlla le impostazioni del dispositivo per il supporto eSIM.",
    howToCheck: "Come verificare manualmente",
    iphoneInstructions: "Impostazioni > Generali > Info > cerca \"SIM Disponibile\" o \"eSIM\"",
    androidInstructions: "Impostazioni > Rete > Schede SIM > cerca \"Aggiungi eSIM\" o \"Scarica SIM\"",
    quickCheck: "Verifica Rapida",
    quickCheckDesc: "Componi *#06# — se vedi un numero EID, il tuo dispositivo supporta eSIM",
    brandsCount: "Il database include oltre 150 dispositivi dei principali marchi",
    dualSim: "Dual SIM",
    fiveGReady: "5G Pronto"
  },
  account: {
    profile: "Profilo",
    orders: "Ordini",
    wishlist: "Preferiti",
    esims: "Le Mie eSIM",
    referral: "Invita Amici",
    invoices: "Fatture",
    noInvoices: "Nessuna fattura",
    noInvoicesDesc: "Richiedi una fattura durante il checkout e apparira qui.",
    personalInfo: "Informazioni Personali",
    edit: "Modifica",
    save: "Salva",
    logout: "Esci",
    fullName: "Nome Completo",
    phone: "Telefono",
    address: "Indirizzo",
    city: "Citta",
    country: "Paese",
    postalCode: "CAP",
    email: "Email",
    flashOffers: "Offerte Flash",
    flashOffersDesc: "Ricevi email quando i prezzi scendono per le tue destinazioni",
    noOrders: "Nessun ordine",
    noOrdersDesc: "Inizia lo shopping e i tuoi ordini appariranno qui",
    browsePlans: "Scopri i Piani",
    orderStatus: "Stato Ordine",
    items: "Articoli",
    orderPlaced: "Ordine Effettuato",
    payment: "Pagamento",
    esimReady: "eSIM Pronta",
    active: "Attiva",
    completed: "Completato",
    processing: "In Elaborazione",
    pending: "In Attesa",
    failed: "Fallito",
    emailSent: "Email inviata",
    emptyWishlist: "La tua lista preferiti e vuota",
    emptyWishlistDesc: "Salva le tue destinazioni preferite per trovarle facilmente",
    browseDestinations: "Scopri Destinazioni",
    added: "Aggiunto",
    noEsims: "Nessuna eSIM",
    noEsimsDesc: "Dopo aver acquistato una eSIM, i tuoi piani appariranno qui",
    installGuide: "Guida Installazione eSIM",
    iphoneSteps: ["Vai su Impostazioni > Cellulare", "Tocca \"Aggiungi eSIM\" o \"Aggiungi Piano Cellulare\"", "Scansiona il QR code dalla tua email", "Segui le istruzioni sullo schermo", "Abilita \"Roaming Dati\" quando sei all'estero"],
    androidSteps: ["Vai su Impostazioni > Rete > Schede SIM", "Tocca \"Aggiungi eSIM\" o \"Scarica SIM\"", "Scansiona il QR code dalla tua email", "Conferma il download", "Abilita \"Roaming Dati\" quando sei all'estero"],
    qrNote: "I QR code vengono inviati via email dopo l'acquisto. Controlla la tua casella per l'email di attivazione.",
    purchased: "Acquistata",
    topup: "Ricarica",
    topupTitle: "Ricarica eSIM",
    topupDesc: "Aggiungi dati alla tua eSIM esistente - senza reinstallare!",
    checkingTopup: "Verifica disponibilit\u00e0...",
    canTopup: "Questa eSIM pu\u00f2 essere ricaricata",
    cannotTopup: "Ricarica non disponibile per questa eSIM",
    cannotTopupReason: "Questo piano eSIM non supporta la ricarica diretta. Dipende dal fornitore del piano. Quando i dati si esauriscono o il piano scade, puoi acquistare un nuovo piano eSIM dal nostro shop.",
    buyNewPlan: "Acquista un nuovo piano eSIM",
    buyNewEsim: "Acquista nuova eSIM",
    buyNewEsimDesc: "Trova il piano perfetto per il tuo prossimo viaggio",
    goToShop: "Vai allo Shop",
    buyAgainFor: "Acquista di nuovo per:",
    recommendedForYou: "Consigliati per te",
    loadingRecommendations: "Caricamento consigli...",
    recBuyAgain: "Riacquista",
    recPopular: "Popolare",
    recTrending: "Tendenza",
    recFrom: "da",
    recPlans: "piani",
    selectPackage: "Seleziona un pacchetto dati",
    dataAmount: "Dati",
    validity: "Validit\u00e0",
    days: "giorni",
    priceLabel: "Prezzo",
    payTopup: "Paga e Ricarica",
    topupProcessing: "Elaborazione ricarica...",
    topupSuccess: "Ricarica applicata con successo!",
    topupFailed: "Ricarica fallita. Riprova.",
    viewQr: "Mostra QR Code",
    hideQr: "Nascondi QR Code",
    simDetails: "Dettagli SIM",
    loadingDetails: "Caricamento dettagli eSIM...",
    dataRemaining: "Dati Rimanenti",
    expiresOn: "Scadenza",
    activePlan: "Piano Attivo",
    noActivePlan: "Nessun piano attivo",
    manageEsim: "Gestisci eSIM",
    backToList: "Torna alla lista",
    copySuccess: "Copiato!",
    scanQr: "Scansiona questo QR code per installare la tua eSIM"
  },
  deal: {
    title: "Offerta del Giorno",
    viewDeal: "Vedi Offerta"
  },
  cookie: {
    text: "Utilizziamo cookie tecnici necessari per il funzionamento del sito e cookie analitici per migliorare la tua esperienza. Consulta la nostra",
    privacyPolicy: "Privacy Policy",
    forMoreInfo: "per maggiori informazioni.",
    acceptAll: "Accetta tutti",
    essentialOnly: "Solo essenziali"
  },
  currency: {
    geoDetected: "Valuta impostata automaticamente su {{symbol}} {{code}} in base alla tua posizione",
    change: "Cambia"
  },
  roamingCalc: {
    title: "Calcolatore Risparmio Roaming",
    subtitle: "Scopri quanto puoi risparmiare con una eSIM rispetto al roaming del tuo operatore. Inserisci i dati e confronta!",
    yourOperator: "Il tuo operatore",
    selectOperator: "Seleziona operatore",
    destination: "Destinazione",
    selectDestination: "Seleziona destinazione",
    dataQuestion: "Quanti GB prevedi di usare?",
    calculateSavings: "Calcola Risparmio",
    withEsimSave: "Con eSIM risparmi",
    estimatedCost: "Costo stimato",
    pricePerGB: "Prezzo per GB",
    plannedData: "Dati previsti",
    total: "Totale",
    esimPlan: "Piano eSIM",
    quantity: "Quantita",
    totalData: "Dati totali",
    buy: "Acquista",
    disclaimer: "* I prezzi roaming sono stime basate sulle tariffe medie degli operatori. I costi effettivi possono variare. Verifica sempre con il tuo operatore prima di viaggiare.",
    avgSavings: "Risparmio medio",
    activation: "Attivazione",
    instant: "Istantanea",
    coverage: "Copertura",
    countries: "paesi",
    otherOperator: "Altro operatore",
    other: "Altro",
    countryIT: "Italia", countryDE: "Germania", countryFR: "Francia", countryES: "Spagna",
    countryPL: "Polonia", countryGB: "Regno Unito", countryUS: "Stati Uniti", countryXX: "Altro",
    destItaly: "Italia", destFrance: "Francia", destGermany: "Germania", destSpain: "Spagna",
    destPoland: "Polonia", destUK: "Regno Unito", destUSA: "Stati Uniti",
    destJapan: "Giappone", destThailand: "Thailandia", destAustralia: "Australia",
    destEurope: "Europa (30+ paesi)", destGlobal: "Globale (100+ paesi)"
  },
  compare: {
    title: "Confronta Piani eSIM",
    backToShop: "Torna allo Shop",
    addMore: "Aggiungi Altri Piani",
    selectAtLeast: "Seleziona almeno 2 piani da confrontare",
    selectAtLeastDesc: "Torna allo shop e clicca l'icona di confronto sui prodotti",
    browseMore: "Esplora Piani eSIM",
    plansSelected: "piani selezionati",
    planSelected: "piano selezionato",
    clearAll: "Cancella tutto",
    compareNow: "Confronta Ora",
    price: "Prezzo",
    data: "Dati",
    validity: "Validita",
    pricePerGB: "Prezzo per GB",
    pricePerDay: "Prezzo per Giorno",
    coverage: "Copertura",
    network: "Rete",
    recommendation: "Il Nostro Consiglio",
    recommendationText: "In base al rapporto qualita-prezzo,",
    bestValue: "Miglior Valore",
    lowest: "Piu Basso",
    mostData: "Piu Dati",
    forMaxData: "Per il massimo dei dati, considera"
  },
  productDetail: {
    backToShop: "Torna allo Shop",
    affordablePlans: "Piani convenienti da",
    keepNumber: "Mantieni il tuo numero",
    instantQR: "Consegna QR code istantanea",
    shareableHotspot: "Hotspot condivisibile",
    fixed: "Fisso",
    unlimited: "Illimitato",
    sort: "Ordina",
    default: "Predefinito",
    cheapest: "Piu Economico",
    byData: "Per Dati",
    addToCart: "Aggiungi al Carrello",
    selectPlan: "Seleziona un piano"
  },
  legal: {
    lastUpdated: "Ultimo aggiornamento: Marzo 2026 | eSIM4You di TelcaVoIP International EU",
    terms: {
      title: "Termini e Condizioni",
      s1: { title: "1. Generale", text: "I presenti Termini e Condizioni regolano l'acquisto e l'utilizzo dei prodotti eSIM venduti tramite esim4you.com, gestito da TelcaVoIP International EU. Effettuando un ordine, accetti di essere vincolato da questi termini." },
      s2: { title: "2. Prodotti e Servizi", text: "Vendiamo piani dati eSIM digitali per viaggi internazionali. Le eSIM vengono consegnate digitalmente tramite QR code al tuo indirizzo email registrato. I piani includono specifiche per traffico dati, periodo di validita e paesi supportati come descritto nella pagina del prodotto." },
      s3: { title: "3. Compatibilita Dispositivi", text: "E responsabilita del cliente verificare che il proprio dispositivo supporti eSIM prima dell'acquisto. Forniamo uno strumento di verifica compatibilita sul nostro sito web. Non siamo responsabili per acquisti effettuati per dispositivi non compatibili." },
      s4: { title: "4. Prezzi e Pagamenti", text: "Tutti i prezzi sono in EUR e includono le tasse applicabili. Accettiamo pagamenti tramite carta di credito/debito (Stripe) e PayPal. Il pagamento viene elaborato al momento dell'acquisto. La eSIM viene consegnata dopo la conferma del pagamento." },
      s5: { title: "5. Consegna", text: "Le eSIM sono prodotti digitali consegnati istantaneamente via email dopo il pagamento. Riceverai un QR code con istruzioni di installazione. Non e prevista spedizione fisica. I tempi di consegna possono variare di qualche minuto a seconda dell'elaborazione email." },
      s6: { title: "6. Politica di Rimborso", text: "Data la natura digitale dei prodotti eSIM:", items: ["Prima dell'attivazione: Rimborso completo disponibile entro 14 giorni dall'acquisto", "Dopo l'attivazione: I rimborsi non sono disponibili una volta che la eSIM e stata installata e attivata su un dispositivo", "Problemi tecnici: In caso di problemi di connettivita, contatta il supporto per assistenza o sostituzione"], refundContact: "Per richiedere un rimborso, contatta" },
      s7: { title: "7. Diritto di Recesso (UE)", text: "Secondo la legge europea sulla protezione dei consumatori, hai il diritto di recedere dall'acquisto entro 14 giorni. Tuttavia, procedendo con l'acquisto e richiedendo la consegna immediata della eSIM digitale, riconosci e accetti di rinunciare al diritto di recesso una volta che la eSIM e stata consegnata e/o attivata." },
      s8: { title: "8. Limitazione di Responsabilita", text: "eSIM4You non e responsabile per interruzioni di rete, limitazioni di velocita o problemi di copertura causati da operatori di rete mobile di terze parti. Forniamo connettivita tramite reti partner e non possiamo garantire un servizio ininterrotto in tutte le condizioni." },
      s9: { title: "9. Contatti", text: "TelcaVoIP International EU" }
    },
    privacy: {
      title: "Informativa sulla Privacy",
      s1: { title: "1. Titolare del Trattamento", text: "TelcaVoIP International EU e il titolare del trattamento dei dati personali raccolti tramite esim4you.com, in conformita con il Regolamento Generale sulla Protezione dei Dati dell'UE (GDPR)." },
      s2: { title: "2. Dati che Raccogliamo", items: ["Dati account: Nome, indirizzo email, password (hash)", "Dati di fatturazione: Nome, indirizzo, numero di telefono (per l'elaborazione degli ordini)", "Dati di pagamento: Elaborati in modo sicuro da Stripe e PayPal (non memorizziamo numeri di carta)", "Dati di utilizzo: Pagine visitate, tipo di dispositivo, browser (analisi anonime)"] },
      s3: { title: "3. Finalita del Trattamento", items: ["Elaborare e consegnare i tuoi ordini eSIM", "Inviare email di conferma ordine e consegna eSIM", "Gestire il tuo account utente e la lista preferiti", "Fornire assistenza clienti", "Rispettare gli obblighi legali"] },
      s4: { title: "4. Base Giuridica (GDPR Art. 6)", items: ["Contratto: Trattamento necessario per l'evasione dell'ordine", "Consenso: Per email di marketing e cookie analitici", "Interesse legittimo: Per la prevenzione delle frodi e il miglioramento del servizio"] },
      s5: { title: "5. Servizi di Terze Parti", items: ["Stripe: Elaborazione pagamenti (conforme PCI-DSS)", "PayPal: Elaborazione pagamenti", "Resend: Consegna email transazionali", "Google: Autenticazione social login"], note: "Questi servizi trattano i dati in conformita con le proprie informative sulla privacy e sono conformi al GDPR." },
      s6: { title: "6. I Tuoi Diritti (GDPR)", intro: "Come residente UE, hai il diritto di:", items: ["Accedere ai tuoi dati personali", "Rettificare dati inesatti", "Richiedere la cancellazione (\"diritto all'oblio\")", "Limitare o opporti al trattamento", "Portabilita dei dati", "Revocare il consenso in qualsiasi momento"], contact: "Per esercitare questi diritti, contatta:" },
      s7: { title: "7. Cookie", text: "Utilizziamo cookie essenziali per la funzionalita del sito (autenticazione, carrello) e cookie analitici opzionali. Puoi gestire le tue preferenze tramite il banner dei cookie o le impostazioni del browser." },
      s8: { title: "8. Conservazione dei Dati", text: "I dati dell'account vengono conservati finche l'account e attivo. I dati degli ordini vengono conservati per 10 anni come richiesto dalla legge fiscale UE. Puoi richiedere la cancellazione dell'account in qualsiasi momento." },
      s9: { title: "9. Contatti", text: "Responsabile della Protezione dei Dati\nTelcaVoIP International EU\nEmail: privacy@esim4you.com" }
    },
    refund: {
      title: "Politica di Rimborso",
      beforeActivation: { title: "Prima dell'Attivazione", text: "Se la tua eSIM non e stata attivata (non installata su un dispositivo), hai diritto a un rimborso completo entro 14 giorni dall'acquisto." },
      afterActivation: { title: "Dopo l'Attivazione", text: "Una volta che la eSIM e stata installata e attivata su un dispositivo, i rimborsi non sono disponibili in quanto il prodotto digitale e stato consumato. Cio e conforme alla Direttiva UE sui Contenuti Digitali (2019/770)." },
      technicalIssues: { title: "Problemi Tecnici", text: "Se riscontri problemi di connettivita o problemi tecnici con la tua eSIM, contatta il nostro team di supporto. Provvederemo a:", items: ["Risolvere il problema entro 24 ore", "Fornire una eSIM sostitutiva se il problema non puo essere risolto", "Emettere un rimborso completo se non e possibile fornire una soluzione funzionante"] },
      howToRequest: { title: "Come Richiedere un Rimborso", text: "Invia un'email a", with: "con:", items: ["Il tuo numero d'ordine", "L'indirizzo email utilizzato per l'acquisto", "Il motivo della richiesta di rimborso"], processing: "I rimborsi vengono elaborati entro 5-10 giorni lavorativi sul metodo di pagamento originale." }
    }
  },
  review: {
    title: "Condividi la Tua Esperienza",
    subtitle: "Aiuta altri viaggiatori condividendo la tua esperienza con la eSIM",
    ratingLabel: "Valutazione",
    textLabel: "La tua recensione",
    placeholder: "Com'e stata la tua esperienza con la eSIM? Qualita della connessione, velocita, facilita di configurazione...",
    submit: "Invia Recensione",
    maybeLater: "Forse Dopo",
    thankYou: "Grazie!",
    published: "La tua recensione e stata pubblicata e aiutera altri viaggiatori.",
    continueBrowsing: "Continua a Navigare",
    invalidLink: "Questo link per la recensione non e valido o e gia stato utilizzato.",
    rating5: "Fantastico!",
    rating4: "Ottimo!",
    rating3: "Buono",
    rating2: "Discreto",
    rating1: "Scarso",
    yourReward: "Il Tuo Premio",
    nextPurchase: "il tuo prossimo acquisto",
    couponNote: "Valido per 30 giorni, uso singolo. Inserisci al checkout."
  },
  referral: {
    title: "Invita Amici, Guadagna Premi",
    subtitle: "Condividi il tuo link: il tuo amico riceve 10% di sconto, tu guadagni 2 euro!",
    yourLink: "Il Tuo Link Referral",
    shareText: "Ottieni il 10% di sconto sul tuo primo acquisto eSIM con il mio link!",
    step1: "Condividi il link",
    step2: "L'amico riceve 10% di sconto",
    step3: "Tu guadagni 2 euro di credito",
    invited: "Invitati",
    clicks: "Click",
    purchases: "Acquisti",
    rewards: "Premi",
    activeCoupons: "Coupon Attivi",
    recentReferrals: "Referral Recenti",
    yourRewards: "I Tuoi Coupon Premio",
    rewardAmount: "Credito 2 euro",
    purchased: "Ha acquistato",
    signedUp: "Registrato"
  },
  tripPlanner: {
    badge: "Trip Planner",
    title: "Pianifica il tuo Viaggio",
    subtitle: "Inserisci le tappe del tuo itinerario e troveremo il piano eSIM ottimale per ogni destinazione",
    destinations: "Tappe del Viaggio",
    firstStop: "Prima tappa (es. Roma)",
    lastStop: "Ultima tappa (es. Londra)",
    middleStop: "Tappa intermedia (es. Parigi)",
    addStop: "Aggiungi tappa",
    daysPerStop: "Giorni per tappa",
    dataNeed: "Consumo dati",
    findBestPlans: "Trova i Piani Migliori",
    optimizing: "Ottimizzazione in corso...",
    yourItinerary: "Il tuo Itinerario",
    stops: "tappe",
    notFound: "Destinazione non trovata nel catalogo",
    plansAvailable: "piani",
    bundleTotal: "Totale Bundle",
    daysEach: "giorni/tappa",
    addAllToCart: "Aggiungi Tutto al Carrello",
    goToCheckout: "Vai al Checkout",
    addedAll: "${added} eSIM aggiunte al carrello!",
    minDestinations: "Inserisci almeno 2 destinazioni",
    error: "Errore nell'ottimizzazione"
  }
};
export default it;
